export default "<div class=\"payment-alert\">\n    <button mat-raised-button mat-button (click)=\"goToPayments()\">Pending payments</button>\n</div>\n";